<template>
    <div @click="closeModal" class="wb-overlay-tooltips">
        <div @click.stop class="wb-overlay-tooltip-anchor-top" :style="{'top': '70px', 'left': '153px'}"  >
            <div class="wb-overlay-tooltip wb-tooltip-top">
                <div class="wb-c-flex-center wb-green">
                    <SVGArrowTooltipUp/>
                </div>
                <div class="wb-tooltip-label">
                    Действия с комнатой
                </div>
                <ul>
                    <li class="wb-tooltip-text">Параметры комнаты</li>
                    <li class="wb-tooltip-text">Цвет стен</li>
                    <li class="wb-tooltip-text">Цвет пола</li>
                </ul>
            </div>
        </div>

        <div
            @click.stop
            class="wb-overlay-tooltip-anchor-center"
            :style="{ width: '560px', top: '50%', right: '55px' }"
        >
            <div class="wb-overlay-tooltip wb-tooltip-top thumbnail_tooltip">
                <img
                    v-on:click="switchVideoOpened"
                    class="thumbnail"
                    src="src/utils/screenshot_vide.webp"
                    alt=""
                />
                <NavbarGreenButton
                    :text="'Посмотреть видеоинструкцию'"
                    v-on:click="switchVideoOpened"
                />
            </div>
        </div>
        <div
            @click.stop
            class="wb-overlay-tooltip-anchor-center"
            :style="{
                width: '100%',
                height: '100%',
                top: '0',
                left: '0',
                zIndex: '1',
                backgroundColor: 'rgba(45, 56, 67, 0.5019607843)',
            }"
            v-if="isVideoOpened"
        >
            <NavbarGreenButton
                :text="'Закрыть'"
                v-on:click="switchVideoOpened"
                :style="{
                    position: 'absolute',
                    top: '5%',
                    left: '50%',
                    transform: 'translate(-50%, 0)',
                }"
            />
            <div
                class="wb-overlay-tooltip-anchor-center"
                :style="{
                    width: '75%',
                    height: '75%',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: '1',
                }"
            >

                <iframe
                    width="100%"
                    height="100%"
                    src="https://rutube.ru/play/embed/5da67744c1cd87e4189c9d876b1c9c41/?p=O5oFNejF5mvSBPVNMXlh-Q"
                    frameBorder="0"
                    allow="clipboard-write; autoplay"
                    allowFullScreen
                ></iframe>
            </div>
        </div>

        <!-- </div> -->

        <div @click.stop class="wb-overlay-tooltip-anchor-top" :style="{'top': '70px', 'left': '428px'}"  >
            <div class="wb-overlay-tooltip wb-tooltip-top">
                <div class="wb-c-flex-center wb-green">
                    <SVGArrowTooltipUp/>
                </div>
                <div class="wb-tooltip-label">
                    Действия с системой
                </div>
                <ul>
                    <li class="wb-tooltip-text">Показать размеры</li>
                    <li class="wb-tooltip-text">Добавить предметы интерьера</li>
                    <li class="wb-tooltip-text">Цвет системы</li>
                    <li class="wb-tooltip-text">Удалить выбранный элемент</li>
                </ul>
            </div>
        </div>

        <div class="wb-overlay-tooltip-anchor-top" :style="{'top': '70px', 'left': '709px'}"  >
            <div @click.stop class="wb-overlay-tooltip wb-tooltip-top">
                <div class="wb-c-flex-center wb-green">
                    <SVGArrowTooltipUp/>
                </div>
                <div class="wb-tooltip-text">
                    Это название проекта. Его можно изменить.
                </div>
            </div>
        </div>

        <div class="wb-overlay-tooltip-anchor-top" :style="{'top': '70px', 'right': '506px'}"  >
            <div @click.stop class="wb-overlay-tooltip wb-tooltip-top">
                <div class="wb-c-flex-center wb-green">
                    <SVGArrowTooltipUp/>
                </div>
                <div class="wb-tooltip-label">
                    Действия со сценой:
                </div>
                <ul>
                    <li class="wb-tooltip-text">Сохранить проект</li>
                    <li class="wb-tooltip-text">Сделать снимок</li>
                    <li class="wb-tooltip-text">Отменить действие</li>
                    <li class="wb-tooltip-text">Повторить действие</li>
                </ul>
            </div>
        </div>

        <div class="wb-overlay-tooltip-anchor-top" :style="{'top': '70px', 'right': '188px'}"  >
            <div @click.stop class="wb-overlay-tooltip wb-tooltip-top">
                <div class="wb-c-flex-center wb-green">
                    <SVGArrowTooltipUp/>
                </div>
                <div class="wb-tooltip-text">
                    Это список комлектующих и аксессуаров, добавленных в сцену. Вы можете оформить заказ выбранных комплектующих, нажав кнопку «Заказать».
                </div>
            </div>
        </div>

        <div class="wb-overlay-tooltip-anchor-left" :style="{'top': '55%', 'left': '158px'}">
            <div @click.stop class="wb-overlay-tooltip wb-tooltip-left">
                <div class="wb-c-flex-center wb-green">
                    <SVGArrowTooltipLeft/>
                </div>
                <div class="wb-tooltip-left-info">
                    <div class="wb-tooltip-label">
                        Это каталог
                    </div>
                    <div class="wb-tooltip-text">
                        Нажмите на категорию, выберите предмет из предложенного списка и перетащите его на сцену. Опоры и крепления добавятся автоматически. Аксессуары не выводятся на сцене, но их можно добавить в заказ.
                    </div>
                </div>

            </div>
        </div>

        <div class="wb-overlay-tooltip-anchor-center " :style="{'top': '50%', 'left': '50%'}">
            <div @click.stop class="wb-overlay-tooltip wb-tooltip-center">
                <div class="wb-tooltip-label">
                    Это сцена
                </div>
                <div class="wb-tooltip-text">
                    Нажмите на объект, чтобы изменить его. Обратите внимание, изменение цвета будет применено сразу ко всей конструкции. Нажмите на окно/дверь, чтобы изменить их размер. Чтобы скопировать объект, зажмите Ctrl и переместите его.
                </div>
            </div>
        </div>

        <div class="wb-overlay-tooltip-anchor-end" :style="{'right': '0px', 'bottom': '85px'}">
            <div @click.stop class="wb-overlay-tooltip wb-tooltip-bottom">
                <div class="wb-tooltip-text">
                    Чтобы показать эти подсказки снова, нажмите на «?».
                </div>
                <div class="wb-tooltip-bottom-btn-line">
                    <NavbarGreenButton :text="'Понятно'" v-on:click="closeModal"/>
                    <div class="wb-green">
                        <SVGArrowTooltipDown/>
                    </div>
                </div>
            </div>
        </div>

      <div class="wb-overlay-tooltip-anchor-center" :style="{'left': '50%', 'bottom': '75px'}" >
        <div @click.stop class="wb-tooltip-advice wb-overlay-tooltip wb-tooltip-center ">
          <div>
            <svg width="30px" height="50px" viewBox="20 0 30 48.00" xmlns="http://www.w3.org/2000/svg" fill="#e8cca5" stroke="#000000" stroke-width="0.00048000000000000007">
              <g id="SVGRepo_bgCarrier" stroke-width="0"/>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
              <g id="SVGRepo_iconCarrier"> <title>exclamation-point-solid</title> <g id="Layer_2" data-name="Layer 2"> <g id="icons_Q2" data-name="icons Q2"> <g> <rect width="48" height="48" fill="none"/> <g> <circle cx="24" cy="40" r="3"/> <path d="M23.8,33h.4a2.2,2.2,0,0,0,2.1-2L28,7.3a4,4,0,1,0-8,0L21.7,31A2.2,2.2,0,0,0,23.8,33Z"/> </g> </g> </g> </g> </g>
            </svg>
          </div>
          <div class="wb-tooltip-text" style="text-align: center">
            Наш конфигуратор работает во всех браузерах,
            но если у Вас есть возможность воспользоваться Google Chrome или Firefox, работа с ним будет еще комфортнее          </div>
        </div>
      </div>

    </div>
</template>

<script>
import { ref } from 'vue';
import SVGArrowTooltipUp from '@/UI/Components/SVG/SVGArrowTooltipUp.vue';
import SVGArrowTooltipLeft from '@/UI/Components/SVG/SVGArrowTooltipLeft.vue';
import NavbarGreenButton from '@/UI/Components/ComponentsNavbar/NavbarGreenButton.vue';
import SVGArrowTooltipDown from '@/UI/Components/SVG/SVGArrowTooltipDown.vue';
import { useUIOnlyStore } from '@/Store/storeUI';

export default {
  name: 'OverlayTooltips',
  components: {
    SVGArrowTooltipDown,
    NavbarGreenButton,
    SVGArrowTooltipLeft,
    SVGArrowTooltipUp,
  },
  setup() {
    const storeUI = useUIOnlyStore();
    const isVideoOpened = ref(false);

    function switchVideoOpened () {
        isVideoOpened.value = !isVideoOpened.value;
    }

    return {
      storeUI,
      isVideoOpened,
      switchVideoOpened
    };
  },
  methods: {
    closeModal() {
      localStorage.setItem('second', true);
      this.storeUI.switchIsTooltip();
    },
  },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/fonts.scss";
@import "CSS/common.scss";
@import "CSS/tooltipStyles.scss";



.wb-overlay-tooltips {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: $tooltipsBG;
    z-index: 500;
}

.wb-overlay-tooltip-anchor-top {
    display: flex;
    align-items: start;
    justify-content: center;
    height: 0;
    width: 0;
    position: absolute;
}

.wb-overlay-tooltip-anchor-left {
    display: flex;
    align-items: center;
    justify-content: start;
    height: 0;
    width: 0;
    position: absolute;
}

.wb-overlay-tooltip-anchor-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0;
    width: 0;
    position: absolute;
}

.wb-overlay-tooltip-anchor-end {
    display: flex;
    align-items: end;
    justify-content: end;
    height: 0;
    width: 0;
    position: absolute;
}

.wb-overlay-tooltip {
    color: $darkBlue;
    box-sizing: border-box;
    flex-shrink: 0;
    flex-grow: 0;
}

.wb-tooltip-top {
    background-color: $white;
    padding: 16px 24px 24px 24px;
    width: 262px;
    display: grid;
    grid-auto-flow: row dense;
    grid-row-gap: 10px;
}

.wb-tooltip-left {
    background-color: $white;
    padding: 24px 24px 24px 16px;
    width: 319px;
    display: grid;
    grid-auto-flow: column dense;
    grid-column-gap: 34px;
}

.wb-tooltip-center {
    background-color: $white;
    padding: 24px;
    width: 316px;
    display: grid;
    grid-auto-flow: row dense;
    grid-row-gap: 10px;
}

.wb-tooltip-bottom {
    background-color: $tooltipsBG2;
    padding: 24px;
    width: 275px;
    display: grid;
    grid-auto-flow: row dense;
    grid-row-gap: 10px;
}

.wb-tooltip-left-info {
    display: grid;
    grid-auto-flow: row dense;
    grid-row-gap: 10px;
}

.wb-tooltip-bottom-btn-line {
    display: flex;
    justify-content: space-between;
}

.wb-tooltip-label {
    @include font-h1-2b;
    text-align: left;
}

.wb-tooltip-text {
    @include font-t1;
    text-align: left;
}

ul {
    padding-left: 20px;
    margin: 0;
}
.wb-tooltip-advice{
  background-color: #fffbe0;
  width: 550px;
  border: 1px solid #e8cca5;
  outline: 2px solid #fffbe0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.thumbnail_tooltip {
    width: 400px;
    justify-items: center;
}

.thumbnail {
    width: 100%;
    transition: opacity .3s ease;
}

.thumbnail:hover {
    cursor: pointer;
    opacity: .8;
}
</style>
